/* eslint-disable react/jsx-pascal-case */
import { message, Button, Col, Form, Tag, Row, Space, Popconfirm, Switch, ProTableOt, Radio, setParamsFilter, useProTableOt, Typography, Tabs } from "./../../ui/ot";
import dayjs from 'dayjs';
import React, { useEffect, useRef, useState } from "react";
import { useNews } from "../controller/NewsController";
import NewsType from './NewsType'
import axios from 'axios';
import NewsForm from "./NewsForm";
import CheckoutMain from "../../checkout/views/CheckoutMain";
import Can from './../../can/views/Can'
import EditorMessage from "../../editor_message/views/EditorMessage";
import TemplateType from "../../template/views/TemplateType";
const News = ({
    defaultSize = 20,
    showSwitch = false,
    showNewsType = false,
    propsShowColumns = ["news_type_name", "news_title", 'news_type_name', 'news_time', 'open_status', 'staff_name', 'announce_time_end', 'news_weight_type_name', 'click_num', 'news_id', 'option'],
    propsCheckSelectRowKeys = [],
    propsCheckSelectedRowsInfo = [],
    propsMode = true,
    onCheckSelectChange = () => { },
    onClickEditNewsType = () => { },
    onClickClickToVisit = () => { },
    permission_level = null, 
}) => {
    axios.interceptors.request.use(
        async (config) => {
            const access_token = localStorage.getItem("access_token");

            if (access_token) {
                config.headers = {
                    ...config.headers,
                    authorization: `Bearer ${access_token}`,
                };
            }
            return config;
        },
        (error) => Promise.reject(error)
    );
    axios.interceptors.response.use(
        response => {
            return response
        },
        function (error) {
            const access_token_url = '/access_token';
            const config = error.config
            if (
                error.response?.status === 401 &&
                config.url === access_token_url
            ) {
                window.location.href = ('/login')
                return Promise.reject(error)
            }

            if (error.response?.status === 401 && !config._retry) {
                config._retry = true
                const refreshToken = localStorage.getItem('refresh_token')
                if (!refreshToken) window.location.href = ('/login')
                return axios
                    .post(access_token_url, {
                        refresh_token: refreshToken
                    })
                    .then(res => {
                        if (res?.status === 201) {
                            localStorage.setItem('access_token', res.data.access_token);
                            config.headers = {
                                ...config.headers,
                                authorization: `Bearer ${localStorage.getItem('access_token')}`,
                            };
                            return axios(config)
                        }
                    })
            }
            return Promise.reject(error)
        }
    )
    const [showColumns, setShowColumns] = useState(propsShowColumns ? propsShowColumns : ["news_type_name", "news_title", 'news_type_name', 'news_time', 'open_status', 'staff_name', 'announce_time_end', 'news_weight_type_name', 'click_num', 'news_id', 'option'])

    const columns = [
        {
            title: '分類',
            dataIndex: 'news_type_name',
            key: 'news_type_name',
        },
        {
            title: '標題',
            dataIndex: 'news_title',
            key: 'news_title',
        },
        {
            title: '公開狀態',
            key: "open_status",
            dataIndex: 'news_time',
            disabled: true,
            render: (text, record, index) => {
                let currentTime = dayjs()
                let news_time = dayjs(text, "YYYY-MM-DD HH:mm:ss")
                let isAnnounce = news_time.isBefore(currentTime)
                if (isAnnounce) {
                    return <Tag color="green">
                        已發佈
                    </Tag>
                }
                else {
                    return <Tag color="red">
                        未發佈
                    </Tag>
                }

            }
        },
        {
            title: '發佈者',
            dataIndex: 'staff_name',
            key: 'staff_name',
        },
        {
            title: '發佈時間',
            key: "news_time",
            dataIndex: 'news_time',

        },
        {
            title: '結束時間',
            key: "announce_time_end",
            dataIndex: 'announce_time_end',

        },
        {
            title: '重要程度',
            dataIndex: 'news_weight_type_name',
            key: 'news_weight_type_name',
        },
        {
            title: '點擊率',
            dataIndex: 'click_num',
            key: 'click_num',
        },
        {
            title: '消息連結',
            dataIndex: 'news_id',
            key: 'news_id',
            disabled: true,
            sorter: false,
            render: (text, record, index) => {
                return <Button
                    type="primary"
                    style={{
                        color: "#fff",
                        backgroundColor: "#A6A6A6"
                    }}
                    onClick={() => {
                        onClickClickToVisit(text)
                        // window.open('/officialweb/news/new/'+text)
                    }}
                >
                    點我前往
                </Button>
            }
        },
        // {
        //     title: '操作',
        //     valueType: 'option',
        //     key: 'option',
        //     fixed: 'right',
        //     sorter: false,
        //     disabled: true,
        //     render: (text, record, _index) => {
        //         return (
        //             <Space wrap>
        //                 <Button
        //                     type="link"
        //                     style={{
        //                         color: '#2BC17B'
        //                     }}
        //                     onClick={() => {
        //                         handleEditRow(record)
        //                     }}
        //                 >
        //                     修改
        //                 </Button>
        //                 <Popconfirm
        //                     title="刪除項目"
        //                     description="確定刪除勾選項目?"
        //                     onConfirm={() => handleDeleteRow(record?.news_id)}
        //                     onCancel={() => { }}
        //                 >
        //                     <Button
        //                         type="link"
        //                         danger>
        //                         刪除
        //                     </Button>
        //                 </Popconfirm>
        //             </Space>
        //         )
        //     }
        // },
    ];
    const [activeKey, setActiveKey] = useState(0);
    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(defaultSize ? defaultSize : 20)
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([])
    const [tabCheckoutAndHold, setTabCheckoutAndHold] = useState('checkout');

    const [checkSelectedRowKeys, setcheckSelectedRowKeys] = useState(propsCheckSelectRowKeys)
    const [checkSelectedRowsInfo, setcheckSelectedRowsInfo] = useState(propsCheckSelectedRowsInfo)
    const [mode, setMode] = useState(!!propsMode ) //true 編輯模式 false 勾選給上層模式
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = []
            let selectRow = []
            if (mode) {
                select_temp = [...selectedRowKeys]
                selectRow = [...selectedRowsInfo]
            }
            else {
                select_temp = [...checkSelectedRowKeys]
                selectRow = [...checkSelectedRowsInfo]
            }
            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.news_id)
                    selectRow.push(value)
                })

            }
            else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.news_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);

                })
            }
            if (mode) {
                setSelectedRowKeys(select_temp)
                setSelectedRowsInfo(selectRow)
            }
            else {
                setcheckSelectedRowKeys(select_temp)
                setcheckSelectedRowsInfo(selectRow)
                onCheckSelectChange(select_temp, selectRow)
            }
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = []
            let selectRow = []
            if (mode) {
                select_temp = [...selectedRowKeys]
                selectRow = [...selectedRowsInfo]
            }
            else {
                select_temp = [...checkSelectedRowKeys]
                selectRow = [...checkSelectedRowsInfo]
            }
            if (selected) {
                select_temp.push(record.news_id)
                selectRow.push(record)
            }
            else {
                select_temp = select_temp.filter(key => key !== record.news_id)
                selectRow = selectRow.filter(row => row.news_id !== record.news_id)
            }
            if (mode) {
                setSelectedRowKeys(select_temp)
                setSelectedRowsInfo(selectRow)
            }
            else {
                setcheckSelectedRowKeys(select_temp)
                setcheckSelectedRowsInfo(selectRow)
                onCheckSelectChange(select_temp, selectRow)
            }
        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };
    const [modalOpen, setModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)

    const [form] = Form.useForm();

    const [axiosMode, setAxiosMode] = useState("get")
    const [showType, setShowType] = useState("News") // 顯示News OR NewsType
    const onCleanSelected = () => {
        if (mode) {
            setSelectedRowKeys([])
            setSelectedRowsInfo([])
        }
        else {
            setcheckSelectedRowKeys([])
            setcheckSelectedRowsInfo([])
        }

    }
    const handleAddRow = () => {
        setAxiosMode("post")
        setModalOpen(true)
        form.resetFields()
    }
    const handleEditRow = (record) => {
        setAxiosMode("patch")
        setModalOpen(true)

        let news_time = dayjs(record?.news_time, "YYYY-MM-DD HH:mm:ss")
        let announce_time_end = !!record?.announce_time_end ? dayjs(record?.announce_time_end, "YYYY-MM-DD HH:mm:ss") : record?.announce_time_end


        form.resetFields()
        form.setFieldsValue({
            ...record,
            news_time,
            announce_time_end
        })
    }
    const handleDeleteRow = (id) => {
        let data = []
        if (id) {
            data = [{
                news_id: id
            }]
        }

        else {
            data = selectedRowsInfo.map((val) => {
                return {
                    news_id: val?.news_id
                }
            })
        }
        if (data.length > 0) {
            deleteNewsData(data)
        }
        else {
            message.info("請選擇項目")
        }
    }

    const onFormFinish = (values) => {

        if (!values?.announce_time_end || values?.announce_time_end === "Invalid Date") {
            values = {
                ...values,
                announce_time_end: null
            }
        }
        if (axiosMode === "post") {
            postNewsData([values])
        }
        else if (axiosMode === "patch") {
            patchNewsData([values])
        }
    }
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功")
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])
            }
            else if (axiosMode === "patch") {
                message.success("修改成功")
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])
            }
            else if (axiosMode === "delete") {
                message.success("刪除成功")
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])

            }
            setModalLoading(false)
            setModalOpen(false)
        }
        else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗")
                actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "patch") {
                message.error("修改失敗")
                actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
                actionRef.current.reloadAndRest();
            }
            setModalLoading(false)
            setModalOpen(false)
        }
    }
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true)
    }

    const {
        getNewsData,
        postNewsData,
        patchNewsData,
        deleteNewsData,
    } = useNews({
        onFinish,
        onBefore,
    })

    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
        transferColumnAntdToShadcn,
        transferSortAntdToShadcn,
    } = useProTableOt({
        columns,
    });
    useEffect(() => {
        checkAll()
    }, [])

    return <>
        <Row>
            <Tabs
                items={[
                    {
                        key: 0,
                        tab: '最新消息'
                    },
                    {
                        key: 1,
                        tab: '消息種類'
                    },
                    {
                        key: 2,
                        tab: '訊息樣板'
                    },
                    {
                        key: 3,
                        tab: '訊息樣板分類'
                    },
                    {
                        key: 4,
                        tab: '小編訊息'
                    },
                ]}
                activeKey={activeKey}
                onChange={(e) => setActiveKey(e)}
            />
        </Row>
        {activeKey == 0 && <>
            <Row>
                {
                    showType === "News" && (
                        <Col span={24}>
                            <Row>
                                <Col span={24}>
                                    <ProTableOt
                                        actionRef={actionRef}
                                        headerTitle={<Space>
                                            {
                                                showSwitch && (
                                                    <Switch
                                                        checked={mode}
                                                        checkedChildren="編輯模式"
                                                        unCheckedChildren="綁定模式"
                                                        onChange={(val) => {
                                                            setMode(val)
                                                            setShowColumns((pre) => {
                                                                if (val) {
                                                                    if (!pre.includes("option")) {
                                                                        return [...pre, 'option']
                                                                    }
                                                                    else {
                                                                        return pre.filter((ele) => {
                                                                            return ele !== "option"
                                                                        })
                                                                    }
                                                                }
                                                            })
                                                        }}
                                                    >

                                                    </Switch>)
                                            }



                                        </Space>}
                                        columns={columns.filter((element) => {
                                            return showColumns.includes(element.key)
                                        })}
                                        check={check}
                                        setCheck={setCheck}
                                        rowKey={'news_id'}
                                        selections={{
                                            // onChange: (index_, data_) => set_data(data_)
                                        }}
                                        toolBarRender={() => [
                                            // mode && <Popconfirm
                                            //     title="刪除消息"
                                            //     description="確定刪除勾選消息?"
                                            //     onConfirm={() => handleDeleteRow()}
                                            //     onCancel={() => { }}
                                            // >
                                            //     <Button
                                            //         type='primary'
                                            //         style={{
                                            //             color: "#000",
                                            //             backgroundColor: "#ffedee"
                                            //         }}

                                            //     >
                                            //         刪除消息
                                            //     </Button>
                                            // </Popconfirm>
                                            !mode && <Button
                                                type='primary'
                                                onClick={() => {
                                                    if (showNewsType) {
                                                        setShowType("NewsType")
                                                    }
                                                    else {
                                                        onClickEditNewsType()
                                                    }
                                                }}
                                                style={{
                                                    backgroundColor: "#edf3ff",
                                                    color: "#000"
                                                }}
                                            >
                                                編輯類別
                                            </Button>
                                        ]}
                                        extra_columns={extra_columns}
                                        set_extra_columns={set_extra_columns}
                                        manage_columns={false}
                                        request={async (params = {}, sort, filter) => {
                                            console.log({
                                                params, sort, filter
                                            })
                                            setAxiosMode("get")
                                            let newParams = {
                                            };
                                            let order = setOrders(sort)
                                            newParams = {
                                                ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                                                ...newParams,
                                                order,
                                                size: params.pageSize,
                                                cur_page: params.current,
                                                custom_filter_value: params.keyword ?? "",
                                                custom_filter_key: custom_filter_key
                                            };
                                            newParams = setParamsFilter({
                                                ...newParams,
                                            });
                                            setPageSize(params?.pageSize ?? 20)

                                            return getNewsData(newParams)
                                        }}
                                        pageSize={pageSize}
                                        rowSelection={{
                                            type: 'checkbox',
                                            selectedRowKeys: mode ? selectedRowKeys : checkSelectedRowKeys,
                                            selectedRowsInfo: mode ? selectedRowsInfo : checkSelectedRowsInfo,
                                            setSelectedRowKeys: setSelectedRowKeys,
                                            setSelectedRowsInfo: setSelectedRowsInfo,
                                            ...rowSelection,
                                        }}
                                        tableAlertOptionRender={() => {
                                            return (
                                                <Space size={16}>
                                                    {/* <Typography.Link>匯出資料</Typography.Link> */}
                                                </Space>
                                            )
                                        }}
                                        tableAlertRender={({
                                            selectedRowKeys,
                                            selectedRows,
                                            // onCleanSelected,
                                        }) => {
                                            return (
                                                <Space size={24}>
                                                    <span>
                                                        已選擇 {selectedRowKeys.length} 項
                                                        <a style={{ marginInlineStart: 8 }} onClick={onCleanSelected}>
                                                            取消選擇
                                                        </a>
                                                    </span>
                                                </Space>
                                            );
                                        }}
                                        scroll={{
                                            x: "max-content"
                                        }}
                                        propsUseData={() => {
                                            return {
                                                postData: postNewsData,
                                                patchData: patchNewsData,
                                                deleteData: deleteNewsData
                                            }
                                        }}
                                        PropsPatchForm={<NewsForm />}
                                        propsPatchOnFinish={({ axiosMode, status }) => {
                                            if (status === "success") {
                                                actionRef.current.reload()
                                            } else {

                                            }
                                        }}
                                        propsPatchOnBefore={() => { }}
                                        propsPatch={permission_level === 1 ? true : false}
                                        modalOpen={modalOpen}
                                        setModalOpen={setModalOpen}
                                        propsDelete={permission_level === 1 ? true : false}
                                        propsPost={permission_level === 1 ? true : false}
                                        propsWidth={1000}
                                        formMode={true}
                                        isMultipleEdit={false}
                                    />
                                </Col>
                            </Row>
                        </Col>
                    )
                }
                {
                    showType === "NewsType" && (
                        <Col span={24}>
                            <NewsType
                                returnButtomText={showNewsType ? null : "返回"}
                                onClickReturnButtom={() => {
                                    setShowType('News')
                                }}
                            />
                        </Col>
                    )
                }
            </Row >
        </>}
        {activeKey == 1 && <>
            <NewsType />
        </>}
        {
            activeKey === 2 && (
                <Row>
                    <Col span={24}>
                        <Can />
                    </Col>
                </Row>
            )
        }
        {
            activeKey === 3 && (
                <Row>
                    <Col span={24}>
                        <TemplateType />
                    </Col>
                </Row>
            )
        }
        {
            activeKey === 4 && (
                <Row>
                    <Col span={24}>
                        <EditorMessage />
                    </Col>
                </Row>
            )
        }
    </>
}
export default News;
